/**
 * Generated by orval v8.4.1 🍺
 * Do not edit manually.
 * Supabase API (v1)
 * Supabase API generated from the OpenAPI specification.<br>Visit [https://supabase.com/docs](https://supabase.com/docs) for a complete documentation.
 * OpenAPI spec version: 1.0.0
 */
import type {
  AuthConfigResponse,
  CreateProviderBody,
  CreateProviderResponse,
  CreateSigningKeyBody,
  CreateThirdPartyAuthBody,
  DeleteProviderResponse,
  GetProviderResponse,
  ListProvidersResponse,
  SigningKeyResponse,
  SigningKeysResponse,
  ThirdPartyAuth,
  UpdateAuthConfigBody,
  UpdateProviderBody,
  UpdateProviderResponse,
  UpdateSigningKeyBody
} from './supabaseAPIV1.schemas';

import { customFetch } from '../fetcher';


/**
 * @summary Set up the project's existing JWT secret as an in_use JWT signing key. This endpoint will be removed in the future always check for HTTP 404 Not Found.
 */
export type v1CreateLegacySigningKeyResponse201 = {
  data: SigningKeyResponse
  status: 201
}

export type v1CreateLegacySigningKeyResponse401 = {
  data: void
  status: 401
}

export type v1CreateLegacySigningKeyResponse403 = {
  data: void
  status: 403
}

export type v1CreateLegacySigningKeyResponse429 = {
  data: void
  status: 429
}

export type v1CreateLegacySigningKeyResponseSuccess = (v1CreateLegacySigningKeyResponse201) & {
  headers: Headers;
};
export type v1CreateLegacySigningKeyResponseError = (v1CreateLegacySigningKeyResponse401 | v1CreateLegacySigningKeyResponse403 | v1CreateLegacySigningKeyResponse429) & {
  headers: Headers;
};

export type v1CreateLegacySigningKeyResponse = (v1CreateLegacySigningKeyResponseSuccess | v1CreateLegacySigningKeyResponseError)

export const getV1CreateLegacySigningKeyUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/config/auth/signing-keys/legacy`
}

export const v1CreateLegacySigningKey = async (ref: string, options?: RequestInit): Promise<v1CreateLegacySigningKeyResponse> => {
  
  return customFetch<v1CreateLegacySigningKeyResponse>(getV1CreateLegacySigningKeyUrl(ref),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}
  

/**
 * @summary Get the signing key information for the JWT secret imported as signing key for this project. This endpoint will be removed in the future, check for HTTP 404 Not Found.
 */
export type v1GetLegacySigningKeyResponse200 = {
  data: SigningKeyResponse
  status: 200
}

export type v1GetLegacySigningKeyResponse401 = {
  data: void
  status: 401
}

export type v1GetLegacySigningKeyResponse403 = {
  data: void
  status: 403
}

export type v1GetLegacySigningKeyResponse429 = {
  data: void
  status: 429
}

export type v1GetLegacySigningKeyResponseSuccess = (v1GetLegacySigningKeyResponse200) & {
  headers: Headers;
};
export type v1GetLegacySigningKeyResponseError = (v1GetLegacySigningKeyResponse401 | v1GetLegacySigningKeyResponse403 | v1GetLegacySigningKeyResponse429) & {
  headers: Headers;
};

export type v1GetLegacySigningKeyResponse = (v1GetLegacySigningKeyResponseSuccess | v1GetLegacySigningKeyResponseError)

export const getV1GetLegacySigningKeyUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/config/auth/signing-keys/legacy`
}

export const v1GetLegacySigningKey = async (ref: string, options?: RequestInit): Promise<v1GetLegacySigningKeyResponse> => {
  
  return customFetch<v1GetLegacySigningKeyResponse>(getV1GetLegacySigningKeyUrl(ref),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * @summary Create a new signing key for the project in standby status
 */
export type v1CreateProjectSigningKeyResponse201 = {
  data: SigningKeyResponse
  status: 201
}

export type v1CreateProjectSigningKeyResponse401 = {
  data: void
  status: 401
}

export type v1CreateProjectSigningKeyResponse403 = {
  data: void
  status: 403
}

export type v1CreateProjectSigningKeyResponse429 = {
  data: void
  status: 429
}

export type v1CreateProjectSigningKeyResponseSuccess = (v1CreateProjectSigningKeyResponse201) & {
  headers: Headers;
};
export type v1CreateProjectSigningKeyResponseError = (v1CreateProjectSigningKeyResponse401 | v1CreateProjectSigningKeyResponse403 | v1CreateProjectSigningKeyResponse429) & {
  headers: Headers;
};

export type v1CreateProjectSigningKeyResponse = (v1CreateProjectSigningKeyResponseSuccess | v1CreateProjectSigningKeyResponseError)

export const getV1CreateProjectSigningKeyUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/config/auth/signing-keys`
}

export const v1CreateProjectSigningKey = async (ref: string,
    createSigningKeyBody: CreateSigningKeyBody, options?: RequestInit): Promise<v1CreateProjectSigningKeyResponse> => {
  
  return customFetch<v1CreateProjectSigningKeyResponse>(getV1CreateProjectSigningKeyUrl(ref),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createSigningKeyBody,)
  }
);}
  

/**
 * @summary List all signing keys for the project
 */
export type v1GetProjectSigningKeysResponse200 = {
  data: SigningKeysResponse
  status: 200
}

export type v1GetProjectSigningKeysResponse401 = {
  data: void
  status: 401
}

export type v1GetProjectSigningKeysResponse403 = {
  data: void
  status: 403
}

export type v1GetProjectSigningKeysResponse429 = {
  data: void
  status: 429
}

export type v1GetProjectSigningKeysResponseSuccess = (v1GetProjectSigningKeysResponse200) & {
  headers: Headers;
};
export type v1GetProjectSigningKeysResponseError = (v1GetProjectSigningKeysResponse401 | v1GetProjectSigningKeysResponse403 | v1GetProjectSigningKeysResponse429) & {
  headers: Headers;
};

export type v1GetProjectSigningKeysResponse = (v1GetProjectSigningKeysResponseSuccess | v1GetProjectSigningKeysResponseError)

export const getV1GetProjectSigningKeysUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/config/auth/signing-keys`
}

export const v1GetProjectSigningKeys = async (ref: string, options?: RequestInit): Promise<v1GetProjectSigningKeysResponse> => {
  
  return customFetch<v1GetProjectSigningKeysResponse>(getV1GetProjectSigningKeysUrl(ref),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * @summary Get information about a signing key
 */
export type v1GetProjectSigningKeyResponse200 = {
  data: SigningKeyResponse
  status: 200
}

export type v1GetProjectSigningKeyResponse401 = {
  data: void
  status: 401
}

export type v1GetProjectSigningKeyResponse403 = {
  data: void
  status: 403
}

export type v1GetProjectSigningKeyResponse429 = {
  data: void
  status: 429
}

export type v1GetProjectSigningKeyResponseSuccess = (v1GetProjectSigningKeyResponse200) & {
  headers: Headers;
};
export type v1GetProjectSigningKeyResponseError = (v1GetProjectSigningKeyResponse401 | v1GetProjectSigningKeyResponse403 | v1GetProjectSigningKeyResponse429) & {
  headers: Headers;
};

export type v1GetProjectSigningKeyResponse = (v1GetProjectSigningKeyResponseSuccess | v1GetProjectSigningKeyResponseError)

export const getV1GetProjectSigningKeyUrl = (ref: string,
    id: string,) => {


  

  return `/v1/projects/${ref}/config/auth/signing-keys/${id}`
}

export const v1GetProjectSigningKey = async (ref: string,
    id: string, options?: RequestInit): Promise<v1GetProjectSigningKeyResponse> => {
  
  return customFetch<v1GetProjectSigningKeyResponse>(getV1GetProjectSigningKeyUrl(ref,id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * @summary Remove a signing key from a project. Only possible if the key has been in revoked status for a while.
 */
export type v1RemoveProjectSigningKeyResponse200 = {
  data: SigningKeyResponse
  status: 200
}

export type v1RemoveProjectSigningKeyResponse401 = {
  data: void
  status: 401
}

export type v1RemoveProjectSigningKeyResponse403 = {
  data: void
  status: 403
}

export type v1RemoveProjectSigningKeyResponse429 = {
  data: void
  status: 429
}

export type v1RemoveProjectSigningKeyResponseSuccess = (v1RemoveProjectSigningKeyResponse200) & {
  headers: Headers;
};
export type v1RemoveProjectSigningKeyResponseError = (v1RemoveProjectSigningKeyResponse401 | v1RemoveProjectSigningKeyResponse403 | v1RemoveProjectSigningKeyResponse429) & {
  headers: Headers;
};

export type v1RemoveProjectSigningKeyResponse = (v1RemoveProjectSigningKeyResponseSuccess | v1RemoveProjectSigningKeyResponseError)

export const getV1RemoveProjectSigningKeyUrl = (ref: string,
    id: string,) => {


  

  return `/v1/projects/${ref}/config/auth/signing-keys/${id}`
}

export const v1RemoveProjectSigningKey = async (ref: string,
    id: string, options?: RequestInit): Promise<v1RemoveProjectSigningKeyResponse> => {
  
  return customFetch<v1RemoveProjectSigningKeyResponse>(getV1RemoveProjectSigningKeyUrl(ref,id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}
  

/**
 * @summary Update a signing key, mainly its status
 */
export type v1UpdateProjectSigningKeyResponse200 = {
  data: SigningKeyResponse
  status: 200
}

export type v1UpdateProjectSigningKeyResponse401 = {
  data: void
  status: 401
}

export type v1UpdateProjectSigningKeyResponse403 = {
  data: void
  status: 403
}

export type v1UpdateProjectSigningKeyResponse429 = {
  data: void
  status: 429
}

export type v1UpdateProjectSigningKeyResponseSuccess = (v1UpdateProjectSigningKeyResponse200) & {
  headers: Headers;
};
export type v1UpdateProjectSigningKeyResponseError = (v1UpdateProjectSigningKeyResponse401 | v1UpdateProjectSigningKeyResponse403 | v1UpdateProjectSigningKeyResponse429) & {
  headers: Headers;
};

export type v1UpdateProjectSigningKeyResponse = (v1UpdateProjectSigningKeyResponseSuccess | v1UpdateProjectSigningKeyResponseError)

export const getV1UpdateProjectSigningKeyUrl = (ref: string,
    id: string,) => {


  

  return `/v1/projects/${ref}/config/auth/signing-keys/${id}`
}

export const v1UpdateProjectSigningKey = async (ref: string,
    id: string,
    updateSigningKeyBody: UpdateSigningKeyBody, options?: RequestInit): Promise<v1UpdateProjectSigningKeyResponse> => {
  
  return customFetch<v1UpdateProjectSigningKeyResponse>(getV1UpdateProjectSigningKeyUrl(ref,id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateSigningKeyBody,)
  }
);}
  

/**
 * @summary Gets project's auth config
 */
export type v1GetAuthServiceConfigResponse200 = {
  data: AuthConfigResponse
  status: 200
}

export type v1GetAuthServiceConfigResponse401 = {
  data: void
  status: 401
}

export type v1GetAuthServiceConfigResponse403 = {
  data: void
  status: 403
}

export type v1GetAuthServiceConfigResponse429 = {
  data: void
  status: 429
}

export type v1GetAuthServiceConfigResponse500 = {
  data: void
  status: 500
}

export type v1GetAuthServiceConfigResponseSuccess = (v1GetAuthServiceConfigResponse200) & {
  headers: Headers;
};
export type v1GetAuthServiceConfigResponseError = (v1GetAuthServiceConfigResponse401 | v1GetAuthServiceConfigResponse403 | v1GetAuthServiceConfigResponse429 | v1GetAuthServiceConfigResponse500) & {
  headers: Headers;
};

export type v1GetAuthServiceConfigResponse = (v1GetAuthServiceConfigResponseSuccess | v1GetAuthServiceConfigResponseError)

export const getV1GetAuthServiceConfigUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/config/auth`
}

export const v1GetAuthServiceConfig = async (ref: string, options?: RequestInit): Promise<v1GetAuthServiceConfigResponse> => {
  
  return customFetch<v1GetAuthServiceConfigResponse>(getV1GetAuthServiceConfigUrl(ref),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * @summary Updates a project's auth config
 */
export type v1UpdateAuthServiceConfigResponse200 = {
  data: AuthConfigResponse
  status: 200
}

export type v1UpdateAuthServiceConfigResponse401 = {
  data: void
  status: 401
}

export type v1UpdateAuthServiceConfigResponse403 = {
  data: void
  status: 403
}

export type v1UpdateAuthServiceConfigResponse429 = {
  data: void
  status: 429
}

export type v1UpdateAuthServiceConfigResponse500 = {
  data: void
  status: 500
}

export type v1UpdateAuthServiceConfigResponseSuccess = (v1UpdateAuthServiceConfigResponse200) & {
  headers: Headers;
};
export type v1UpdateAuthServiceConfigResponseError = (v1UpdateAuthServiceConfigResponse401 | v1UpdateAuthServiceConfigResponse403 | v1UpdateAuthServiceConfigResponse429 | v1UpdateAuthServiceConfigResponse500) & {
  headers: Headers;
};

export type v1UpdateAuthServiceConfigResponse = (v1UpdateAuthServiceConfigResponseSuccess | v1UpdateAuthServiceConfigResponseError)

export const getV1UpdateAuthServiceConfigUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/config/auth`
}

export const v1UpdateAuthServiceConfig = async (ref: string,
    updateAuthConfigBody: UpdateAuthConfigBody, options?: RequestInit): Promise<v1UpdateAuthServiceConfigResponse> => {
  
  return customFetch<v1UpdateAuthServiceConfigResponse>(getV1UpdateAuthServiceConfigUrl(ref),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateAuthConfigBody,)
  }
);}
  

/**
 * @summary Creates a new third-party auth integration
 */
export type v1CreateProjectTpaIntegrationResponse201 = {
  data: ThirdPartyAuth
  status: 201
}

export type v1CreateProjectTpaIntegrationResponse401 = {
  data: void
  status: 401
}

export type v1CreateProjectTpaIntegrationResponse403 = {
  data: void
  status: 403
}

export type v1CreateProjectTpaIntegrationResponse429 = {
  data: void
  status: 429
}

export type v1CreateProjectTpaIntegrationResponseSuccess = (v1CreateProjectTpaIntegrationResponse201) & {
  headers: Headers;
};
export type v1CreateProjectTpaIntegrationResponseError = (v1CreateProjectTpaIntegrationResponse401 | v1CreateProjectTpaIntegrationResponse403 | v1CreateProjectTpaIntegrationResponse429) & {
  headers: Headers;
};

export type v1CreateProjectTpaIntegrationResponse = (v1CreateProjectTpaIntegrationResponseSuccess | v1CreateProjectTpaIntegrationResponseError)

export const getV1CreateProjectTpaIntegrationUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/config/auth/third-party-auth`
}

export const v1CreateProjectTpaIntegration = async (ref: string,
    createThirdPartyAuthBody: CreateThirdPartyAuthBody, options?: RequestInit): Promise<v1CreateProjectTpaIntegrationResponse> => {
  
  return customFetch<v1CreateProjectTpaIntegrationResponse>(getV1CreateProjectTpaIntegrationUrl(ref),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createThirdPartyAuthBody,)
  }
);}
  

/**
 * @summary Lists all third-party auth integrations
 */
export type v1ListProjectTpaIntegrationsResponse200 = {
  data: ThirdPartyAuth[]
  status: 200
}

export type v1ListProjectTpaIntegrationsResponse401 = {
  data: void
  status: 401
}

export type v1ListProjectTpaIntegrationsResponse403 = {
  data: void
  status: 403
}

export type v1ListProjectTpaIntegrationsResponse429 = {
  data: void
  status: 429
}

export type v1ListProjectTpaIntegrationsResponseSuccess = (v1ListProjectTpaIntegrationsResponse200) & {
  headers: Headers;
};
export type v1ListProjectTpaIntegrationsResponseError = (v1ListProjectTpaIntegrationsResponse401 | v1ListProjectTpaIntegrationsResponse403 | v1ListProjectTpaIntegrationsResponse429) & {
  headers: Headers;
};

export type v1ListProjectTpaIntegrationsResponse = (v1ListProjectTpaIntegrationsResponseSuccess | v1ListProjectTpaIntegrationsResponseError)

export const getV1ListProjectTpaIntegrationsUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/config/auth/third-party-auth`
}

export const v1ListProjectTpaIntegrations = async (ref: string, options?: RequestInit): Promise<v1ListProjectTpaIntegrationsResponse> => {
  
  return customFetch<v1ListProjectTpaIntegrationsResponse>(getV1ListProjectTpaIntegrationsUrl(ref),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * @summary Removes a third-party auth integration
 */
export type v1DeleteProjectTpaIntegrationResponse200 = {
  data: ThirdPartyAuth
  status: 200
}

export type v1DeleteProjectTpaIntegrationResponse401 = {
  data: void
  status: 401
}

export type v1DeleteProjectTpaIntegrationResponse403 = {
  data: void
  status: 403
}

export type v1DeleteProjectTpaIntegrationResponse429 = {
  data: void
  status: 429
}

export type v1DeleteProjectTpaIntegrationResponseSuccess = (v1DeleteProjectTpaIntegrationResponse200) & {
  headers: Headers;
};
export type v1DeleteProjectTpaIntegrationResponseError = (v1DeleteProjectTpaIntegrationResponse401 | v1DeleteProjectTpaIntegrationResponse403 | v1DeleteProjectTpaIntegrationResponse429) & {
  headers: Headers;
};

export type v1DeleteProjectTpaIntegrationResponse = (v1DeleteProjectTpaIntegrationResponseSuccess | v1DeleteProjectTpaIntegrationResponseError)

export const getV1DeleteProjectTpaIntegrationUrl = (ref: string,
    tpaId: string,) => {


  

  return `/v1/projects/${ref}/config/auth/third-party-auth/${tpaId}`
}

export const v1DeleteProjectTpaIntegration = async (ref: string,
    tpaId: string, options?: RequestInit): Promise<v1DeleteProjectTpaIntegrationResponse> => {
  
  return customFetch<v1DeleteProjectTpaIntegrationResponse>(getV1DeleteProjectTpaIntegrationUrl(ref,tpaId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}
  

/**
 * @summary Get a third-party integration
 */
export type v1GetProjectTpaIntegrationResponse200 = {
  data: ThirdPartyAuth
  status: 200
}

export type v1GetProjectTpaIntegrationResponse401 = {
  data: void
  status: 401
}

export type v1GetProjectTpaIntegrationResponse403 = {
  data: void
  status: 403
}

export type v1GetProjectTpaIntegrationResponse429 = {
  data: void
  status: 429
}

export type v1GetProjectTpaIntegrationResponseSuccess = (v1GetProjectTpaIntegrationResponse200) & {
  headers: Headers;
};
export type v1GetProjectTpaIntegrationResponseError = (v1GetProjectTpaIntegrationResponse401 | v1GetProjectTpaIntegrationResponse403 | v1GetProjectTpaIntegrationResponse429) & {
  headers: Headers;
};

export type v1GetProjectTpaIntegrationResponse = (v1GetProjectTpaIntegrationResponseSuccess | v1GetProjectTpaIntegrationResponseError)

export const getV1GetProjectTpaIntegrationUrl = (ref: string,
    tpaId: string,) => {


  

  return `/v1/projects/${ref}/config/auth/third-party-auth/${tpaId}`
}

export const v1GetProjectTpaIntegration = async (ref: string,
    tpaId: string, options?: RequestInit): Promise<v1GetProjectTpaIntegrationResponse> => {
  
  return customFetch<v1GetProjectTpaIntegrationResponse>(getV1GetProjectTpaIntegrationUrl(ref,tpaId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * @summary Creates a new SSO provider
 */
export type v1CreateASsoProviderResponse201 = {
  data: CreateProviderResponse
  status: 201
}

export type v1CreateASsoProviderResponse401 = {
  data: void
  status: 401
}

export type v1CreateASsoProviderResponse403 = {
  data: void
  status: 403
}

export type v1CreateASsoProviderResponse404 = {
  data: void
  status: 404
}

export type v1CreateASsoProviderResponse429 = {
  data: void
  status: 429
}

export type v1CreateASsoProviderResponseSuccess = (v1CreateASsoProviderResponse201) & {
  headers: Headers;
};
export type v1CreateASsoProviderResponseError = (v1CreateASsoProviderResponse401 | v1CreateASsoProviderResponse403 | v1CreateASsoProviderResponse404 | v1CreateASsoProviderResponse429) & {
  headers: Headers;
};

export type v1CreateASsoProviderResponse = (v1CreateASsoProviderResponseSuccess | v1CreateASsoProviderResponseError)

export const getV1CreateASsoProviderUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/config/auth/sso/providers`
}

export const v1CreateASsoProvider = async (ref: string,
    createProviderBody: CreateProviderBody, options?: RequestInit): Promise<v1CreateASsoProviderResponse> => {
  
  return customFetch<v1CreateASsoProviderResponse>(getV1CreateASsoProviderUrl(ref),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createProviderBody,)
  }
);}
  

/**
 * @summary Lists all SSO providers
 */
export type v1ListAllSsoProviderResponse200 = {
  data: ListProvidersResponse
  status: 200
}

export type v1ListAllSsoProviderResponse401 = {
  data: void
  status: 401
}

export type v1ListAllSsoProviderResponse403 = {
  data: void
  status: 403
}

export type v1ListAllSsoProviderResponse404 = {
  data: void
  status: 404
}

export type v1ListAllSsoProviderResponse429 = {
  data: void
  status: 429
}

export type v1ListAllSsoProviderResponseSuccess = (v1ListAllSsoProviderResponse200) & {
  headers: Headers;
};
export type v1ListAllSsoProviderResponseError = (v1ListAllSsoProviderResponse401 | v1ListAllSsoProviderResponse403 | v1ListAllSsoProviderResponse404 | v1ListAllSsoProviderResponse429) & {
  headers: Headers;
};

export type v1ListAllSsoProviderResponse = (v1ListAllSsoProviderResponseSuccess | v1ListAllSsoProviderResponseError)

export const getV1ListAllSsoProviderUrl = (ref: string,) => {


  

  return `/v1/projects/${ref}/config/auth/sso/providers`
}

export const v1ListAllSsoProvider = async (ref: string, options?: RequestInit): Promise<v1ListAllSsoProviderResponse> => {
  
  return customFetch<v1ListAllSsoProviderResponse>(getV1ListAllSsoProviderUrl(ref),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * @summary Gets a SSO provider by its UUID
 */
export type v1GetASsoProviderResponse200 = {
  data: GetProviderResponse
  status: 200
}

export type v1GetASsoProviderResponse401 = {
  data: void
  status: 401
}

export type v1GetASsoProviderResponse403 = {
  data: void
  status: 403
}

export type v1GetASsoProviderResponse404 = {
  data: void
  status: 404
}

export type v1GetASsoProviderResponse429 = {
  data: void
  status: 429
}

export type v1GetASsoProviderResponseSuccess = (v1GetASsoProviderResponse200) & {
  headers: Headers;
};
export type v1GetASsoProviderResponseError = (v1GetASsoProviderResponse401 | v1GetASsoProviderResponse403 | v1GetASsoProviderResponse404 | v1GetASsoProviderResponse429) & {
  headers: Headers;
};

export type v1GetASsoProviderResponse = (v1GetASsoProviderResponseSuccess | v1GetASsoProviderResponseError)

export const getV1GetASsoProviderUrl = (ref: string,
    providerId: string,) => {


  

  return `/v1/projects/${ref}/config/auth/sso/providers/${providerId}`
}

export const v1GetASsoProvider = async (ref: string,
    providerId: string, options?: RequestInit): Promise<v1GetASsoProviderResponse> => {
  
  return customFetch<v1GetASsoProviderResponse>(getV1GetASsoProviderUrl(ref,providerId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * @summary Updates a SSO provider by its UUID
 */
export type v1UpdateASsoProviderResponse200 = {
  data: UpdateProviderResponse
  status: 200
}

export type v1UpdateASsoProviderResponse401 = {
  data: void
  status: 401
}

export type v1UpdateASsoProviderResponse403 = {
  data: void
  status: 403
}

export type v1UpdateASsoProviderResponse404 = {
  data: void
  status: 404
}

export type v1UpdateASsoProviderResponse429 = {
  data: void
  status: 429
}

export type v1UpdateASsoProviderResponseSuccess = (v1UpdateASsoProviderResponse200) & {
  headers: Headers;
};
export type v1UpdateASsoProviderResponseError = (v1UpdateASsoProviderResponse401 | v1UpdateASsoProviderResponse403 | v1UpdateASsoProviderResponse404 | v1UpdateASsoProviderResponse429) & {
  headers: Headers;
};

export type v1UpdateASsoProviderResponse = (v1UpdateASsoProviderResponseSuccess | v1UpdateASsoProviderResponseError)

export const getV1UpdateASsoProviderUrl = (ref: string,
    providerId: string,) => {


  

  return `/v1/projects/${ref}/config/auth/sso/providers/${providerId}`
}

export const v1UpdateASsoProvider = async (ref: string,
    providerId: string,
    updateProviderBody: UpdateProviderBody, options?: RequestInit): Promise<v1UpdateASsoProviderResponse> => {
  
  return customFetch<v1UpdateASsoProviderResponse>(getV1UpdateASsoProviderUrl(ref,providerId),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateProviderBody,)
  }
);}
  

/**
 * @summary Removes a SSO provider by its UUID
 */
export type v1DeleteASsoProviderResponse200 = {
  data: DeleteProviderResponse
  status: 200
}

export type v1DeleteASsoProviderResponse401 = {
  data: void
  status: 401
}

export type v1DeleteASsoProviderResponse403 = {
  data: void
  status: 403
}

export type v1DeleteASsoProviderResponse404 = {
  data: void
  status: 404
}

export type v1DeleteASsoProviderResponse429 = {
  data: void
  status: 429
}

export type v1DeleteASsoProviderResponseSuccess = (v1DeleteASsoProviderResponse200) & {
  headers: Headers;
};
export type v1DeleteASsoProviderResponseError = (v1DeleteASsoProviderResponse401 | v1DeleteASsoProviderResponse403 | v1DeleteASsoProviderResponse404 | v1DeleteASsoProviderResponse429) & {
  headers: Headers;
};

export type v1DeleteASsoProviderResponse = (v1DeleteASsoProviderResponseSuccess | v1DeleteASsoProviderResponseError)

export const getV1DeleteASsoProviderUrl = (ref: string,
    providerId: string,) => {


  

  return `/v1/projects/${ref}/config/auth/sso/providers/${providerId}`
}

export const v1DeleteASsoProvider = async (ref: string,
    providerId: string, options?: RequestInit): Promise<v1DeleteASsoProviderResponse> => {
  
  return customFetch<v1DeleteASsoProviderResponse>(getV1DeleteASsoProviderUrl(ref,providerId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}
  

